import React, { useLayoutEffect } from "react";
import ReactDOM from "react-dom/client";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import {
  registerOfflineServiceWorker,
  syncOfflineServiceWorkerClientContext,
} from "./offline/offlineGalleryManager";

const offlineServiceWorkerRegistration = registerOfflineServiceWorker();

const OfflineServiceWorkerRouteSync = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    void offlineServiceWorkerRegistration.then((registration) => {
      if (registration) {
        return syncOfflineServiceWorkerClientContext(
          `${window.location.origin}${location.pathname}${location.search}`
        );
      }
      return undefined;
    });
  }, [location.pathname, location.search]);

  return null;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <OfflineServiceWorkerRouteSync />
      <DndProvider backend={HTML5Backend}>
        <Provider store={store}>
          <App />
        </Provider>
      </DndProvider>
    </BrowserRouter>
  </React.StrictMode>
);
